export interface IPickupOption {
  _id: string;
  name: string;
  geoUri: string;
  address: String;
  weekDay: number;
  startMinute: number;
  durationMinutes: number;
  hoursBeforeLocking: number;
  active: boolean;
  defaultContact: IMembership;
  acceptHelpOut: boolean;
}

export interface IExtraBase {
  name: string;
  unit: string;
  producer: string;
  description: string;
}

export interface IExtra {
  _id: string;
  name: string;
  note: string;
  unit: string;
  extraBases: IExtraBase[];
  price: number;
  deadline: string;
}

export interface ISeason {
  _id: string;
  eventIntervalInDays: number;
  firstEventDate: string;
  numberOfEvents: number;
  name: string;
  activePickupOptions: IPickupOption[];
  availableExtras: IExtra[];
  basketPrice: number;
  priceIntroductionFr: string;
  priceIntroductionEn: string;
  extraIntroductionFr: string;
  extraIntroductionEn: string;
  extraLinkTextFr: string;
  extraLinkTextEn: string;
  extraLinkFr: string;
  extraLinkEn: string;
  prices: IPrice[];
  paymentDeadlines: string[];
}

export interface IPriceBase {
  name: string,
  description: string,
}

export interface IPrice {
  _id : string,
  price: number,
  priceBases: IPriceBase[];
}

export interface IMail {
  _id: string;
  date: string;
  sent: boolean;
  subject: string;
  message: string;
}

export interface IPickupEvent {
  _id: string;
  season: ISeason;
  pickupOption: IPickupOption;
  eventNumber: number;
  adminNote: string;
  pickupOptionOverride: IPickupOption;
  startDateOverride: string;
  durationMinutesOverride: number;
  canceled: boolean;
  mails: IMail[];
  availableExtras: string[];
  helpOut: IUser;
  // TODO: Only used for overriging now. Should be handled differently
  startDate: Date;
  newContact: IMembership;
  pickupContact: IMembership;
}

export interface IPickupUserEvent{
  _id: string;
  pickupEvent: IPickupEvent;
  basket: IBasket;
  pickupEventOverride: IPickupEvent;
  absent: boolean;
  done: boolean;
  delegate: string;
  userNote: string;
  editable: boolean;
}

export interface IUser {
  _id: string;
  email: string;
  role: string;
  password: string;
  membership: IMembership
}

export interface IMembership {
  _id: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  zip: string;
  country: string;
  phoneNumber: string;
  baskets: IBasket[];
  creationDate: Date;
}

export interface IBasket {
  _id: string;
  membership: IMembership;
  season: ISeason;
  defaultPickupOption: IPickupOption;
  extras: [{
    quantity: number;
    extra: IExtra;
    totalPrice: number;
  }];
  price: number;
  newPrice: IPrice;
  enable: boolean;
  numPaymentsExpected: number;
  payments: IPayment[];
  creationDate: Date;
  memberType: string;
  memberReferenceName: string;
}

export interface IPayment {
  _id: string;
  date: string;
  amount: number;
}

export interface IMessage {
  _id: string;
  module: string;
  action: string;
  subject: string;
  text: string;
  enable: boolean;
}

export interface ISeasonUtilsService{
  getDateForInterval(season: ISeason, number: number) ;
  getDeadlinesForPayments(season: ISeason);
  getDeadlinesForNumberOfPayments(season: ISeason, numberOfPayments: number);
  getStartDateForPickup(season: ISeason, pickupOption: IPickupOption);
  getEndDateForPickup(season: ISeason, pickupOption: IPickupOption);
}

export interface IPickupUtilsService{
  getDateForInterval: Function;
  getStartDateFor(season: ISeason, pickupOption: IPickupOption, pickupEvent: IPickupEvent);
  getEndDateFor(season: ISeason, pickupOption: IPickupOption, pickupEvent: IPickupEvent);
  getPickupDay(season: ISeason, pickupOption: IPickupOption);
  getStartTime(pickupOption: IPickupOption);
  getEndTime(pickupOption: IPickupOption);
}

export interface IBasketUtilsService {
  getPrice(basket: IBasket);
}

export interface IPickupOptionsService{
  reload();
  get();
}

export interface IOptionsService{
  reload();
  getActiveSeason();
  setActiveSeason(season: ISeason);
  getOpenRegistrationsSeason();
  setOpenRegistrationsSeason(season: ISeason);
}

export interface IMessagesService {
  reload();
  getBasketActions();
  getBasketMessage(action);
  setBasketMessage(message: IMessage);
  sendMail(message: IMessage, memberships, extraEmails: string[]);
}

export interface IExtraEvent{
  title: string,
  date: Date,
  location: IPickupOption,
  description: string,
  durationMinutes: number
}



// WEBPACK FOOTER //
// ./client/app/interfaces.ts